// @flow
import React, { Component } from 'react'
import { translations } from '../../../shared/localize'
import _ from 'lodash'
import Select from '../../controls/Select'
import Switcher from '../../controls/Switcher'
import ExpandingDropdown from '../../AdvertisementsTable/ExpandingDropdown'
import type { OptionType, StatisticFilter } from '../../types'
import styled, { type StyledComponent } from 'styled-components'
import matchesNotFloat from '../../controls/FloatValueMatcher'

const Wrapper: StyledComponent<Object, any, any> = styled.div`
  width: 100%;
  padding: 5px;
`
const Item = styled.div`
  padding: 10px 0;
`
const Button = styled.div`
  margin-top: 15px;
`

type Props = {|
  isPopupOpen: boolean,
  isLoading: boolean,
  statisticField: string,
  statisticFields: Array<string>,
  statisticFilters: Array<StatisticFilter>,
  onFilterChange: Function,
  onChange: Function
|}

type State = {|
  comparison: string,
  value: string
|}

const signT = translations.campaigns_table.statistic_filter
const headerT = translations.table_headers

export default class StatisticFieldPopup extends Component<Props, State> {
  constructor(props: Props) {
    super(props)

    this.state = {
      comparison: 'less',
      value: ''
    }
  }

  render() {
    return (
      <ExpandingDropdown
        isOpen={this.props.isPopupOpen}
        triggerText={this.renderTrigger()}
        onChange={(isPopupOpen) => {
          this.dropdownChanged(isPopupOpen)
        }}
      >
        {this.renderPopupContent()}
      </ExpandingDropdown>
    )
  }

  renderTrigger() {
    return (
      <Select
        value={this.props.statisticField}
        options={this.statisticFieldOptions()}
        disabled={this.props.isLoading}
        onChange={(statisticField) => {
          this.setState({ comparison: 'less', value: '' })
          this.props.onChange({ statisticField }, () => this.triggerChanged())
        }}
      />
    )
  }

  triggerChanged() {
    const { isPopupOpen, statisticField } = this.props
    if (_.isEqual(statisticField, 'all')) this.props.onFilterChange([])
    if (!isPopupOpen && !_.isEqual(statisticField, 'all'))
      this.props.onChange({ isPopupOpen: !isPopupOpen })
  }

  dropdownChanged(isPopupOpen: boolean) {
    if (!isPopupOpen) this.props.onChange({ isPopupOpen })
  }

  renderPopupContent() {
    return (
      <Wrapper className="t-StatisticFilterPopup">
        <Switcher
          value={this.state.comparison}
          options={[
            { id: 'less', name: signT.less },
            { id: 'more', name: signT.more },
            { id: 'equal', name: signT.equal }
          ]}
          labelRenderer={(option) => {
            return option.name
          }}
          onChange={(comparison) => this.setState({ comparison })}
        />
        <Item className="t-ValueInput">
          <input
            value={this.state.value}
            onChange={(e) => this.valueChanged(e.target.value)}
            type="text"
            className="input-item input-item-small"
          />
        </Item>
        <Button>
          <button
            className="btn btn-success"
            onClick={() => {
              this.props.onChange({ isPopupOpen: !this.props.isPopupOpen })
              this.updateFilters()
            }}
          >
            {signT.apply}
          </button>
        </Button>
      </Wrapper>
    )
  }

  updateFilters() {
    const { onFilterChange, statisticFilters, statisticField } = this.props
    const { comparison, value } = this.state
    const newFilter = {
      field: statisticField,
      comparison: comparison,
      value: value ? parseFloat(value) : 0
    }
    this.setState({ comparison: 'less', value: '' })
    onFilterChange([...statisticFilters, newFilter])
  }

  valueChanged(value: string) {
    if (matchesNotFloat(value)) return
    this.setState({ value })
  }

  statisticFieldOptions(): Array<OptionType> {
    const firstOption = [{ id: 'all', name: signT.all }]
    return _.concat(
      firstOption,
      _.map(this.props.statisticFields, (field) => {
        return { id: field, name: headerT[field] }
      })
    )
  }
}
